const starsCount = document.querySelector("[data-js='starsCount']");

if (starsCount) {
  var numberOfChecked = $("input:radio:checked").length;
  var totalCheckboxes = $("input:radio").length;
  var numberNotChecked = totalCheckboxes - numberOfChecked;

  console.log(numberOfChecked + "numberOfChecked");
  console.log(totalCheckboxes + "totalCheckboxes");
  console.log(numberNotChecked + "numberNotChecked");
}
